import { createContext } from "react";
const ItemFeatureContext = createContext({});
export default ItemFeatureContext;
